/**
 * Slider API service layer.
 *
 * Pure axios wrappers — no state management. Each function maps 1:1 to a backend
 * endpoint. Used by both the legacy useSliders hook and the new TanStack Query hooks.
 */
import { api } from "api";
import {
    addSlider,
    deleteSlider,
    editSlider,
    getSliderData,
    toggleSliderHidden,
} from "api/apiURLs";

/** Fetch all sliders (admin view — no area filtering, includes hidden). */
export const getSliders = async () => {
    const response = await api.get(getSliderData);
    return response.data;
};

/** Create a new slider. Expects FormData (image file + fields). */
export const createSlider = async (data) => {
    const response = await api.post(addSlider, data);
    return response.data;
};

/** Partially update a slider. Expects FormData with `id` field included. */
export const updateSlider = async (data) => {
    const response = await api.patch(`${editSlider + data.get("id")}`, data);

    return response.data;
};

/** Hard-delete a slider by ID. */
export const removeSlider = async (id) => {
    const response = await api.delete(`${deleteSlider}${id}`);
    return response.data;
};

/**
 * Saves the order of the sliders on the customer's home screen. `ids` is every
 * slider id, in the order to show them. The API answers 409 when the list no
 * longer matches the table (another admin added or deleted one).
 */
export const saveSliderOrder = async (ids) => {
    const response = await api.put("api/slider/order", { ids });
    return response.data;
};

/**
 * Toggle a slider's isHidden flag. Used by the inline visibility button in the
 * admin slider list — flips the current state without needing the full payload.
 */
export const toggleIsHidden = async (id) => {
    const response = await api.patch(`${toggleSliderHidden}${id}/toggle-hidden`);
    return response.data;
};
